import React from 'react'

export default function Time_tracker() {
const params = new URLSearchParams(window.location.search);

const taskId = params.get('task_id');
const projectId = params.get('project_id');
const taskName = params.get('task_name');
const member_name = params.get('member_name');
const member_id = params.get('member_id');
const member_company_id = params.get('mem_com_id');
const company_name = params.get('comname');
const project_name = params.get('active_pro_name');

  return (
    <div>
        <h2>{company_name}</h2>
      <h3>{taskName}</h3>
    <p>Member Name: {member_name}</p>
    <p>Project Name: {project_name}</p>
    </div>
  )
}
